import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Form } from "@ant-design/compatible";
import { Modal, Button, Input } from "antd";
import { _newLine } from '@/utils/helpers';
import BaseRadioList from '@/components/Elements/BaseRadios';
import { createLabo, updateLabo } from "@/redux/actions/laboActions";
import { isMobile } from "react-device-detect";

function LaboForm({ form, visible, currentItem, onCancel, loadData }) {
    const [isLoading, setIsLoading] = useState(false);
    const dispatch = useDispatch();
    const { getFieldDecorator, validateFields, resetFields } = form;

    const handleClose = () => {
        resetFields();
        setIsLoading(false);
        onCancel();
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        validateFields(async (err, values) => {
            if (!err) {
                setIsLoading(true);
                try {
                    if (currentItem) {
                        await dispatch(updateLabo(currentItem.id, values));
                    } else {
                        await dispatch(createLabo(values));
                    }
                    loadData();
                    handleClose();
                } catch (error) {
                    setIsLoading(false);
                }
            }
        });
    };

    return (
        <Modal
            visible={visible}
            title={currentItem ? "Sửa bản ghi" : "Thêm mới bản ghi"}
            width={isMobile ? "100%" : "40%"}
            onCancel={handleClose}
            maskClosable={false}
            footer={[
                <Button key="back" onClick={handleClose}>Huỷ</Button>,
                <Button loading={isLoading} key="submit" type="primary" onClick={handleSubmit}>
                    {currentItem ? "Cập nhật" : "Thêm mới"}
                </Button>
            ]}
        >
            {visible && (
                <Form layout='vertical' onSubmit={handleSubmit}>
                    <Form.Item label="Tên labo">
                        {getFieldDecorator("name", {
                            rules: [{ required: true, message: "Trường bắt buộc!" }],
                            initialValue: currentItem?.name || ""
                        })(<Input />)}
                    </Form.Item>

                    <Form.Item label="Điện thoại">
                        {getFieldDecorator("phone", {
                            rules: [{ required: false }],
                            initialValue: currentItem?.phone || ""
                        })(<Input />)}
                    </Form.Item>

                    <Form.Item label="Địa chỉ">
                        {getFieldDecorator("address", {
                            rules: [{ required: false }],
                            initialValue: currentItem?.address || ""
                        })(<Input />)}
                    </Form.Item>

                    <Form.Item label="Trạng thái">
                        {getFieldDecorator("status", {
                            rules: [{ required: true, message: "Vui lòng chọn!" }],
                            initialValue: currentItem?.status ?? 1
                        })(
                            <BaseRadioList
                                options={[
                                    { label: "Kích hoạt", value: 1 },
                                    { label: "Chưa kích hoạt", value: 0 }
                                ]}
                            />
                        )}
                    </Form.Item>

                    <Form.Item label="Ghi chú">
                        {getFieldDecorator("note", {
                            rules: [{ required: false }],
                            initialValue: currentItem ? _newLine(currentItem.note) : ""
                        })(<Input.TextArea />)}
                    </Form.Item>
                </Form>
            )}
        </Modal>
    );
}

export default Form.create({ name: "LaboForm" })(LaboForm);
